/**
 * Created by mh on 2018/9/29.
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { observer, inject } from 'mobx-react';
import { observable, computed } from 'mobx';

import { Switch, Redirect, Link } from 'react-router-dom';
import PrivateRoute from '../PrivateRoute.jsx';

import { ArtworkUpload } from './ArtworkUpload';

import Spinner from '../Spinner';
import ArtworkReplacementTile from './ArtworkReplacementTile';

const availableReplacementServices = [
    {
        name: 'CoverartArchive.org',
        type: 'coverartarchive',
    },
    {
        name: 'Apple Music',
        type: 'applemusic',
    },
];

const ArtworkReplacementList = observer(({ service, replacements, replacementAction }) => (
    <div>
        <div className="row">
            <div className="col">
                Retrieved {replacements.length} artworks on {service.name}
            </div>
        </div>
        <div className="row">
            {replacements.map((repl, index) => (
                <ArtworkReplacementTile
                    key={index}
                    source={repl.source}
                    existingId={repl.asset_id}
                    artworkUrl={repl.artworks[0].url}
                    artist={repl.recording.artist}
                    title={repl.recording.title}
                    releaseTitle={repl.release.title}
                    releaseDate={repl.release.date}
                    releaseRef={repl.reference}
                    replacementAction={replacementAction}
                />
            ))}
        </div>
    </div>
));

@inject('assets')
@observer
class SearchArtwork extends Component {
    @observable
    replacementOptions = [];

    @observable
    replacingArtwork = false;

    @observable
    replacedArtwork = false;

    @observable
    replacementImage = null;

    @observable
    replacementService = null;

    @observable
    replacementArtist = '';

    @observable
    replacementTitle = '';

    @observable
    uploadReplacementImage = '';

    @observable
    dirtyReplacement = false;

    @computed
    get hasReplacements() {
        return this.replacementOptions && this.replacementOptions.length > 0;
    }

    fetchData = (service) => {
        // Set local service and fetch data
        this.dirtyReplacement = false;
        this.replacementService = service;
        const {
            match: {
                params: { id },
            },
        } = this.props;
        this.props.assets.fetchArworkReplacements(
            id,
            this.replacementService.type,
            this.replacementArtist,
            this.replacementTitle,
        );
    };

    replaceArtwork = async (
        source,
        externalRef,
        artist,
        releaseTitle,
        releaseDate,
        width,
        height,
        contentType,
        image,
        existingId,
    ) => {
        console.log(`Replacing artwork of ${this.props.match.params.id} with ${contentType}`);
        this.replacingArtwork = true;
        this.replacementImage = image;
        if (source.indexOf(':') < 0) {
            console.error(`Source is expected to be of the form company:service but got ${source}`);
            return;
        }
        if (source === 'deliverdotmedia:existing' && (!existingId || !existingId.length)) {
            console.error(
                `Source is existing element therefore required existingId but got ${existingId}`,
            );
            return;
        }

        const audioId = this.props.match.params.id;

        // Step 1 - create new asset of type ContentType with related to be asset of audio
        const createData = {
            type: 'still',
            name: `ArtWork - ${artist}, ${releaseTitle}`,
            mime_type: contentType,
            description: `ArtWork added by deliver.media from ${source}`,
            metadata: {
                Artist: artist,
                Album: releaseTitle,
                ReleaseDate: releaseDate,
                Source: source,
            },
            related: [
                {
                    name: 'audio',
                    asset_id: audioId,
                },
            ],
            tags: ['artwork'],
            // Expect source to be musicbrainz:coverartarchive
            // dmrn:musicbrainz:coverartarchive:::release/cf184133-7daa-44cb-8309-91023be848dc/cover-art
            external_references: [{ dmrn: `dmrn:${source}:::${externalRef}` }],
        };

        const { assets } = this.props;
        console.log(JSON.stringify(createData));
        let newArtworkAssetId = null;
        let existingArtworkId = existingId;
        try {
            const newArtworkAsset = await assets.createAsset(createData);
            newArtworkAssetId = newArtworkAsset.id;

            // TODO callback is bad
            console.log(`New Artwork Asset Id is ${newArtworkAssetId} - ${image}`);
            debugger;
            // Upload artwork to Service
            const imageData = Buffer.from(image.split(',')[1], 'base64');
            // TODO check length
            const stored = await assets.storeAssetData('still', contentType, imageData);
            // Link artwork to asset add storage location
            const { storageLocation } = stored;
            storageLocation.metadata = {};
            storageLocation.metadata.width = width;
            storageLocation.metadata.height = height;

            const locationAdded = await assets.addStorageLocation(
                newArtworkAssetId,
                storageLocation,
            );
            // Call DMDS application
            const statesApplied = await assets.applyAllStates(newArtworkAssetId);
        } catch (err) {
            if (
                err.response &&
                err.response.status &&
                err.response.status === 409 &&
                err.response.data.existing_asset
            ) {
                const existingArtwork = err.response.data.existing_asset;
                console.log('ARTWORK ASSET EXISTING', existingArtwork);
                // Check if already linked identical asset
                existingArtworkId = existingArtwork.id;
            } else {
                // TODO Handle
                console.log(err);
                // Redirect to the new asset
                this.replacingArtwork = false;
                this.replacedArtwork = true;
                return;
            }
        }
        if (existingArtworkId) {
            if (
                assets.asset.related &&
                assets.asset.related.find((a) => a.asset_id === existingArtworkId)
            ) {
                console.log(
                    'Audio Asset is already related to identical existing artwork asset. Aborting replacement.',
                );
                // Redirect to the new asset
                this.replacingArtwork = false;
                this.replacedArtwork = true;
                return;
            }
            // Instead of increment use asset id as link param
            const updatedOldRelation = {
                name: `audio.${audioId}`,
                asset_id: audioId,
            };
            const updatedOldRelationData = await assets.addOrUpdateRelated(
                existingArtworkId,
                updatedOldRelation,
            );
            newArtworkAssetId = existingArtworkId;
        }

        // Unlink existing artwork if any
        if (assets.asset.id !== audioId) {
            // We have not the audio in store yet
            // Fetch it
            await assets.fetchAsset(audioId);
            await assets.fetchRelated(audioId);
        }
        const currentArtwork = assets.related.find((s) => s.relation === 'artwork');
        if (currentArtwork) {
            // Move current artwork to artwork.1...
            let index = 1;
            while (assets.related.find((s) => s.relation === `artwork.${index}`)) {
                index += 1;
            }
            const updatedOldRelation = {
                name: `artwork.${index}`,
                asset_id: currentArtwork.id,
            };
            const updatedOldRelationData = await assets.addOrUpdateRelated(
                audioId,
                updatedOldRelation,
            );
        }

        // Link Audio to new Artwork
        const artworkLink = {
            name: 'artwork',
            asset_id: newArtworkAssetId,
        };
        const assetLinkUpdate = await assets.addOrUpdateRelated(audioId, artworkLink);

        // RELOAD Asset
        // TODO provide other way of reloading the asset using dirty method or dirty flag
        // assets.fetchAsset(audioId);
        // assets.fetchRelated(audioId);

        // Redirect to the new asset
        this.replacingArtwork = false;
        this.replacedArtwork = true;
    };

    componentDidMount = () => {
        const { assets } = this.props;
        const { asset } = assets;

        if (asset && asset.metadata) {
            this.replacementArtist = asset.metadata.Artist;
            this.replacementTitle = asset.metadata.Album
                ? asset.metadata.Album
                : asset.metadata.Title;
        }
    };

    componentWillReceiveProps = (nextProps) => {
        const {
            match: {
                params: { id },
            },
        } = this.props;
        if (nextProps.match.params.id !== id) {
            // Id changes
            // this.fetchData(nextProps.match.params.id);
            this.replacementOptions = [];
            this.replacingArtwork = false;
            this.replacedArtwork = false;
            this.replacementImage = null;
        }
    };

    updateArtist = (event) => {
        this.replacementArtist = event.target.value ? event.target.value : '';
        this.dirtyReplacement = true;
    };

    updateTitle = (event) => {
        this.replacementTitle = event.target.value ? event.target.value : '';
        this.dirtyReplacement = true;
    };

    render() {
        const {
            assets: {
                fetchingArtworkReplacements,
                fetchedArtworkReplacements,
                assetArtworkReplacements,
            },
            match,
        } = this.props;
        return this.replacedArtwork ? (
            <Redirect to={match.url.replace('/replaceartwork', '/details')} />
        ) : (
            <div className="mt-3">
                <h3>
                    <FormattedMessage
                        id="Assets.ReplaceArtwork.Search"
                        defaultMessage="Search alternative Artwork"
                    />
                </h3>

                <div className="form-inline">
                    <input
                        type="text"
                        className="form-control mb-2 mr-sm-2"
                        placeholder="Artist"
                        name="Replacement Artist"
                        value={this.replacementArtist}
                        onChange={this.updateArtist}
                    />
                    <input
                        type="text"
                        className="form-control mb-2 mr-sm-2"
                        placeholder="Album or Title"
                        name="Replacement Title"
                        value={this.replacementTitle}
                        onChange={this.updateTitle}
                    />
                </div>
                <Switch>
                    <PrivateRoute
                        exact
                        path={`${match.path}/`}
                        component={() => (
                            <React.Fragment>
                                {availableReplacementServices.map((service) => (
                                    <Link
                                        key={service.type}
                                        onClick={() => this.fetchData(service)}
                                        className="btn btn-primary mb-2 mr-sm-2"
                                        to={`${match.url}${match.url.endsWith('/') ? '' : '/'}${
                                            service.type
                                        }`}
                                    >
                                        <FormattedMessage
                                            id={`Assets.ReplaceArtwork.SearchOn_${service.type}`}
                                            defaultMessage={`Search on ${service.name}`}
                                        />
                                    </Link>
                                ))}
                                <Link
                                    onClick={() =>
                                        this.fetchData({
                                            name: 'Existing Artworks',
                                            type: 'existing',
                                        })
                                    }
                                    className="btn btn-primary mb-2 mr-sm-2"
                                    to={`${match.url}${match.url.endsWith('/') ? '' : '/'}existing`}
                                >
                                    <FormattedMessage
                                        id={`Assets.ReplaceArtwork.SearchOn_Existing`}
                                        defaultMessage={`Link existing Artwork`}
                                    />
                                </Link>

                                <hr />
                                <h3>
                                    <FormattedMessage
                                        id="Assets.ReplaceArtwork.Upload"
                                        defaultMessage="Upload Artwork"
                                    />
                                </h3>
                                <ArtworkUpload
                                    uploadArtworkAction={this.replaceArtwork}
                                    initialArtist={this.replacementArtist}
                                    initialTitle={this.replacementTitle}
                                />
                            </React.Fragment>
                        )}
                    />
                    <PrivateRoute
                        exact
                        path={`${match.path}coverartarchive`}
                        component={observer(() => {
                            if (this.dirtyReplacement) {
                                return <Redirect to={`${match.url}/`} />;
                            }
                            if (this.replacingArtwork) {
                                return <Spinner />;
                            }
                            if (fetchingArtworkReplacements || !fetchedArtworkReplacements) {
                                return <Spinner />;
                            }
                            return (
                                <ArtworkReplacementList
                                    service={this.replacementService}
                                    replacements={assetArtworkReplacements}
                                    replacementAction={this.replaceArtwork}
                                />
                            );
                        })}
                    />
                    <PrivateRoute
                        exact
                        path={`${match.path}applemusic`}
                        component={observer(() => {
                            if (this.dirtyReplacement) {
                                return <Redirect to={`${match.url}/`} />;
                            }
                            if (this.replacingArtwork) {
                                return <Spinner />;
                            }
                            if (fetchingArtworkReplacements || !fetchedArtworkReplacements) {
                                return <Spinner />;
                            }
                            return (
                                <ArtworkReplacementList
                                    service={this.replacementService}
                                    replacements={assetArtworkReplacements}
                                    replacementAction={this.replaceArtwork}
                                />
                            );
                        })}
                    />
                    <PrivateRoute
                        exact
                        path={`${match.path}existing`}
                        component={observer(() => {
                            if (this.dirtyReplacement) {
                                return <Redirect to={`${match.url}/`} />;
                            }
                            if (this.replacingArtwork) {
                                return <Spinner />;
                            }
                            if (fetchingArtworkReplacements || !fetchedArtworkReplacements) {
                                return <Spinner />;
                            }
                            return (
                                <ArtworkReplacementList
                                    service={this.replacementService}
                                    replacements={assetArtworkReplacements}
                                    replacementAction={this.replaceArtwork}
                                />
                            );
                        })}
                    />
                    {/* <PrivateRoute exact path={`${match.path}audioplayer/`} component={AssetAudioPlayerComponent} /> */}

                    {/* <Redirect to={`${match.path}details/`} /> */}
                </Switch>
            </div>
        );
    }
}

SearchArtwork.wrappedComponent.propTypes = {
    // auth: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    assets: PropTypes.object,
};

export default injectIntl(SearchArtwork);
